/** Anchor of the contact CTA section, the in-page fallback "Partner with us" can point to. */
export const CONTACT_ANCHOR = '#contact';

/** The partner enquiry form "Partner with us" opens (in a new tab) unless the env overrides it. */
export const PARTNER_FORM_URL = 'https://wkf.ms/4yegLeB';

/**
 * Target of every "Partner with us" button: the partner form by default, or
 * `VITE_CONTACT_URL` when set (`#contact` keeps the CTA section as the destination).
 */
export const CONTACT_URL: string = import.meta.env.VITE_CONTACT_URL || PARTNER_FORM_URL;

/**
 * True when "Partner with us" leads somewhere beyond the CTA section itself (a form, a
 * booking page, a mailto:). The CTA section only shows the button in that case.
 */
export const HAS_CONTACT_DESTINATION = CONTACT_URL !== CONTACT_ANCHOR;

/** True for an off-site destination, which opens in a new tab. */
export const isExternalUrl = (url: string): boolean => /^https?:\/\//.test(url);

/** The API documentation, a second static entry (`docs/index.html`) built beside the page. */
export const DOCS_URL = '/docs/';

/**
 * Host every endpoint in the API documentation is quoted under: the payment gateway, unless
 * the env overrides it. No trailing slash.
 */
export const API_BASE_URL: string = (
  import.meta.env.VITE_API_BASE_URL || 'https://payment.xcoinglobal.com'
).replace(/\/+$/, '');

/** Address the API documentation names for API merchant keys. */
export const SUPPORT_EMAIL: string =
  import.meta.env.VITE_SUPPORT_EMAIL || 'support@xcoinglobal.com';
